import { connectedStore } from '../../store';
import actions from '../actions';

const addLocale = ({ destinationLocale, originLocale, isMultilingualSite, translateOptions }) =>
  new Promise((resolve, reject) => {
    const store = connectedStore.get();
    store.dispatch(
      actions.addLocale(
        { destinationLocale, originLocale, isMultilingualSite, translateOptions },
        resolve,
        reject
      )
    );
  });

export default addLocale;
